module.exports = __webpack_public_path__ + "img-dashboard/register/document-circle-white.8ae4ec1f.png";